<template>
  <div id="home" class="page-container" :style="{ 'backgroundImage': 'url(\'' + bg_image + '\')' }">
      <b-row>
        <b-col><img src="assets/logo_trans.png" /></b-col>
        <b-col></b-col>
        <b-col><span class="phone"><!-- 0800 701 8105 --><img src="assets/0800_header.png" /></span></b-col>
      </b-row>

      <div class="box w-660px pull-right">
          <h1 class="m-t-70">Neste fim de ano aproveite para fazer um teste auditivo!</h1>
          <h3 class="m-t-20"><span class="text-gray">Em minutos você saberá como está sua audição e ainda ganhará um <span class="text-green">cupom de desconto</span> para ser utilizado em um ponto de atendimento <span class="text-green">Phonak.</span></span></h3>
          <h6 class="m-t-30">Atenção: Este teste é apenas uma triagem auditiva, ele não substitui um exame auditivo, por exemplo, "audiometria".</h6>

          <h1 class="m-t-70 m-l-60 p-b-0">Comece Já!</h1>
          <router-link class="nav-link" active-class="active" to="/cadastre">
            <b-button pill variant="success" class="w-55 boldit enviar">Fazer o teste</b-button>
          </router-link>
      </div>

  </div>

</template>

<script>

export default {
  name: "Home",
  data() {
    return {
        bg_image: require('../../assets/capa.png')
    }
  }
}
</script>

<style scoped>
#home {
  padding-top:35px;
  text-align: center;
}

#home .box {
  text-align: left;
}

#home
.phone {
  font-family: 'rotissansnormal';
  color: #96c303;
  font-size: 1.7rem;
  font-weight: bold;
}



@media only screen
  and (max-device-width: 599px) {
  .page-container {
    background-size: 100% !important;
  }
  .page-container .box {
    width: 100% !important;
    background-color: white;
    margin-top: 400px;
    padding: 0px 20px;
  }
  h1 {
    font-size: 2rem;
    text-align: center;
  }

  .enviar {
    width:100% !important;
    margin-bottom: 15px;
  }

  .phone {
    width: 320px;
    display: block;
    text-align: left;
    padding-left: 15px;
  }
  .phone img {
    width:140px;
  }

  .m-l-60 {
    margin-left: 20px;
  }
}
</style>
